import { render } from "./AlertCardList.vue?vue&type=template&id=05b36c70&scoped=true&ts=true"
import script from "./AlertCardList.vue?vue&type=script&lang=ts"
export * from "./AlertCardList.vue?vue&type=script&lang=ts"

import "./AlertCardList.vue?vue&type=style&index=0&id=05b36c70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b36c70"]])

export default __exports__